
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buy-back-telefoane",
      function () {
        return require("private-next-pages/buy-back-telefoane.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buy-back-telefoane"])
      });
    }
  